<template>
    <div class="insurance-target-section">
        <ul class="insurance-target-section__list">
            <li class="insurance-target-section__item"
                v-for="card in insuranceTargetCards" 
                :key="card.iconName" >
                <InsuranceTargetCard :text="card.text" :icon-name="card.iconName" />
            </li>
        </ul>
        <p class="insurance-target-section__comment">
            С полным списком возможных объектов страхования можно ознакомиться в
            <RouterLink class="insurance-target-section__comment-link"
                to="/">
            Правилах страхования
        </RouterLink>
        </p>
    </div>
</template>

<script>
import InsuranceTargetCard from '@/components/ui/InsuranceTargetCard';
export default {
    name: 'InsuranceTargets',
    components: {
        InsuranceTargetCard
    },
    data() {
        return {
            insuranceTargetCards: [
                {
                    text: 'Недвижимое имущество: здания и сооружения (конструктивные элементы), в том числе арендованные, внутренняя и внешняя отделка, стекла, инженерное оборудование',
                    iconName: 'building-white'
                },
                {
                    text: 'Товары в обороте - сырье и материалы, полуфабрикаты, незавершенная производством продукция, готовая продукция, покупные товары для последующей перепродажи',
                    iconName: 'triangle-white'
                },
                {
                    text: 'Иное оборудование, используемое страхователем в его зданиях и сооружениях',
                    iconName: 'judge-gavel-white'
                },
                {
                    text: 'Электронное оборудование, компьютерная техника, оргтехника',
                    iconName: 'monitor-white'
                },
                {
                    text: 'Инструменты, производственный и хозяйственный инвентарь',
                    iconName: 'plug-white'
                },
                {
                    text: 'Производственное и технологическое оборудование, силовые и другие машины, используемые в хозяйственной деятельности',
                    iconName: 'square-steps-white'
                },
                {
                    text: 'Мебель, предметы интерьера',
                    iconName: 'box-white'
                },
            ]
        }
    }
}
</script>

<style scoped lang="scss">
.insurance-target-section {
    &__list {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        row-gap: rem($gap-medium);

        @media #{$screen-small} {
            flex-direction: column;
        }
    }

    &__item {
        &:nth-child(1), &:nth-child(2) {
            @include flex-width-two-in-row($gap-medium);
        }

        &:nth-child(3), &:nth-child(4), &:nth-child(5) {
            @include flex-width-three-in-row($gap-medium);
        }

        &:nth-child(6) {
            width: calc(75.5% - $gap-medium / 2);

            @media #{$screen-big} {
                width: calc(65% - $gap-medium / 2);
            }
        }
        
        &:nth-child(7) {
            width: calc(24.5% - $gap-medium / 2);

            @media #{$screen-big} {
                width: calc(35% - $gap-medium / 2);
            }
        }

        @media #{$screen-small} {
            width: 100% !important;
        }
    }

    &__comment {
        @include text-average($font-weight-medium);

        width: 50%;
        margin-top: rem($gap-medium);

        color: $color-text-weekened-low;

        @media #{$screen-big} {
            font-size: rem($font-size-normal);
        }

        @media #{$screen-medium} {
            font-size: rem($font-size-small);

            width: 70%;
        }

        @media #{$screen-small} {
            width: 100%;
        }
        
        &-link {
            color: $primary-weekened;
            text-decoration: underline;
            text-underline-offset: rem(4px);
        }
    }
}
</style>